import React from 'react';
import { Box, Dialog, DialogTitle, DialogContent, CircularProgress } from '@mui/material';

type Props = {
  open: boolean;
  title?: string;
};

export default function LoadingDialog({ open, title = 'กำลังโหลด' }: Props) {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      // For MUI v5, backdrop click is disabled by default with onClose={() => {}} and no close button
    >
      <DialogTitle sx={{ textAlign: 'center' }}>{title}</DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight={80}
          width={{ xs: 160, sm: 220 }}
          pt={1}
          pb={5}
        >
          <CircularProgress />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
